import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CellEditorModule, GenericDaterangeInputModule, GenericInputModule } from '@sla-ng/ui-material';
import { AssignedReferenceFiguresDialogModule } from './assigned-reference-figures-dialog/assigned-reference-figures-dialog.module';
import { CostCenterDialogModule } from './cost-center-dialog/cost-center-dialog.module';
import { CostCenterGroupDialogModule } from './cost-center-group-dialog/cost-center-group-dialog.module';
import { CostCenterPage } from './cost-center.page';
import { HourlyWageDialogModule } from './hourly-wage-dialog/hourly-wage-dialog.module';

export * from './cost-center.page';
export * from './cost-center-dialog/cost-center-dialog.module';
export * from './cost-center-group-dialog/cost-center-group-dialog.module';
export * from './assigned-reference-figures-dialog/assigned-reference-figures-dialog.module';
export * from './hourly-wage-dialog/hourly-wage-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: CostCenterPage,
    },
];

@NgModule({
    declarations: [ CostCenterPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatInputModule,
        MatIconModule,
        MatTableModule,
        MatButtonModule,
        MatMomentDateModule,
        CostCenterDialogModule,
        HourlyWageDialogModule,
        CostCenterGroupDialogModule,
        AssignedReferenceFiguresDialogModule,
        TranslateModule,
        MatProgressBarModule,
        MatTabsModule,
        CellEditorModule,
        MatTooltipModule,
        GenericDaterangeInputModule,
        ReactiveFormsModule,
        GenericInputModule,
        MatDateRangeInput,
        MatDateRangePicker,
        MatDatepickerToggle,
        MatEndDate,
        MatStartDate,
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ],
})
export class CostCenterPageModule {
}
